import VideoTpl from "../VideoTpl";
import {checkCreateResOK, getCreatedInstanceId} from "../../../api/apiUtil";
import {createWebview, webviewLoad} from "../../../api/nativeComponent/compWebview";
import {appendSubView} from "../../../api/nativeComponent/compVisibleCommon";
import {closeAd} from "../../../api/nativeComponent/compCommon";
import {VideoBridgeGetFileInfo} from "../../../api";

export default class VideoTplH5 extends VideoTpl {
    constructor(props) {
        super(props);

        let MTG_SDKContext = window.MTG_SDKContext
        if (MTG_SDKContext && MTG_SDKContext.unitId && MTG_SDKContext.unitSetting && MTG_SDKContext.sdkSetting) {
            this.unitId = MTG_SDKContext.unitId
            this.unitSetting = MTG_SDKContext.unitSetting
            this.sdkSetting = MTG_SDKContext.sdkSetting
            this.appSetting = MTG_SDKContext.appSetting
        } else {
            console.warn('当前实例初始化失败, 缺少 MTG_SDKContext')
        }
    }

    async init({JsBridgeRes}) {
        super.init({JsBridgeRes});

        // 初始化上下文
        let SDKContext = await this.initSDKContext()
        SDKContext.broadcastText = '在这里输入要广播的内容'
        SDKContext.campaignList[0].video_url_dec = 'https://cdn-adn-https-baidu.rayjump.com/cdn-adn/vh/20/01/22/00/09/3dfe9e63ca88d0bd7aebed520b295593.mp4'
        SDKContext.campaignList[1].video_url_dec = 'https://cdn-adn-https-baidu.rayjump.com/cdn-adn/vh/19/07/25/15/07/9ed786af559b169cabf90fed0e7fc4c5.mp4'
        window.MTG_RENDER(SDKContext)
    }

    show() {
        super.show();
    }

    /**
     * 创建一个 ViewType 为 4 的原生播放模板视图
     * @param campaign
     * @returns {Promise<*[]>}
     */
    create({campaign}) {
        return new Promise(async (resolve, reject) => {
            // 创建 WebView
            let rect = {top: 100, left: 100, right: 100, bottom: 100, width: 160, height: 90}
            let createWebViewRes = await this.createWebview({campaign, rect})
            if (checkCreateResOK(createWebViewRes)) {
                this.webViewId = getCreatedInstanceId(createWebViewRes)

            } else {
                reject({createWebViewRes})
                console.error('初始化 webview 实例失败, 将不再继续创建子 playerView: ', {createWebViewRes})
            }
        })
    }

    preload({id}) {
        let unitId = this.unitId
        return webviewLoad({unitId, id})
    }

    append({parentCmptId, childCmptId, rect}) {
        let unitId = this.unitId
        return appendSubView({unitId, parentCmptId, childCmptId, rect})
    }

    closeAd({id}) {
        let unitId = this.unitId
        return closeAd({unitId, id})
    }

    async createWebview({campaign, rect}) {
        let unitId = this.unitId
        let filePath = await this.getFilePathByRemoteUrl(campaign.rv.template_url)
        return createWebview({unitId, filePath, rect})
    }

    async createPlayerView({campaign = {}}) {
        let unitId = this.unitId
        let sdkSetting = this.sdkSetting
        return createH5PlayerView({unitId, campaign})
    }

    async getFilePathByRemoteUrl(url = '') {
        let filePath = url
        let unitId = this.unitId
        let resource = [{
            type: 2,
            ref: url
        }]
        let filePathConfig = await VideoBridgeGetFileInfo({unitId, resource})
        console.log('----------------------------', {filePathConfig})
        if (filePathConfig && filePathConfig.resource && filePathConfig.resource[0] && filePathConfig.resource[0][url] && filePathConfig.resource[0][url].path) {
            filePath = filePathConfig.resource[0][url].path
        } else {
            console.warn('获取 filePath 失败: ', {url, filePathConfig})
        }
        return filePath
    }

}